import { render, staticRenderFns } from "./NewProjectType.vue?vue&type=template&id=07aaa93d&"
import script from "./NewProjectType.vue?vue&type=script&lang=js&"
export * from "./NewProjectType.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports